<main class="main">
  <div class="content container">
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">الرئيسية</li>
          <li class="breadcrumb-item active">اضافة كتاب اعفاء</li>
        </ol>
      </nav>
    </div>

    <h1>اضافة كتاب اعفاء</h1>

    <form [formGroup]="exemptionForm" (ngSubmit)="addExemptionBook()">
      <div class="row">
        <div class="col-md-6 py-2">
          <span>رقم الكتاب</span>
          <input type="number" class="form-control" formControlName="bookNumber">
          <div class="text-danger" *ngIf="exemptionForm.get('bookNumber')?.touched && exemptionForm.get('bookNumber')?.invalid">
            هذا الحقل مطلوب
          </div>
        </div>

        <div class="col-md-6 py-2">
          <span>الرقم الضريبي</span>
          <input type="number" class="form-control" formControlName="taxNumber">
          <div class="text-danger" *ngIf="exemptionForm.get('taxNumber')?.touched && exemptionForm.get('taxNumber')?.invalid">
            هذا الحقل مطلوب
          </div>
        </div>

        <div class="col-md-6 py-2">
          <span>تاريخ انتهاء الكتاب</span>
          <input type="date" class="form-control" formControlName="expireDate">
          <div class="text-danger" *ngIf="exemptionForm.get('expireDate')?.touched && exemptionForm.get('expireDate')?.invalid">
            هذا الحقل مطلوب
          </div>
        </div>

        <div class="col-md-6 py-2">
          <span>صورة عن الكتاب</span>
          <input type="file" class="form-control" (change)="onUploadFile($event)">
          <div class="text-danger" *ngIf="exemptionForm.get('file')?.touched && exemptionForm.get('file')?.invalid">
            هذا الحقل مطلوب
          </div>
        </div>
      </div>

      <br><br>

      <button class="btn btn-primary" type="submit">حفظ</button>
    </form>
  </div>
</main>

<br>
<br>
<br>
<br>
<br>